import React from 'react';
import Button, { ButtonType } from 'components/Button';
import { getFinancialCheckupWebsiteUrl } from 'enums/ProfessionGroup';

interface BackToWebsiteProps {
  text?: string;
  onClick?: () => void;
  className?: string;
}

const BackToWebsite = ({ text = 'Back to Plannery Website', onClick, className }: BackToWebsiteProps) => {
  const handleGetBack = () => {
    window.open(getFinancialCheckupWebsiteUrl());
  };

  return (
    <Button className={className} type={ButtonType.Secondary} onClick={onClick || handleGetBack}>
      {text}
    </Button>
  );
};

export default BackToWebsite;
